/*!
 * Copyright (c) 2018-2019 Digital Bazaar, Inc. All rights reserved.
 */
'use strict';

var api = {};
module.exports = api;

var base64url = require('./base64url');

api.encode = base64url.encode;
api.decode = base64url.decode;